import { connect } from "react-redux";
import { mapStateToMyClubsProps, mapDispatchToMyClubsProps } from "../mapToProps"; 
import { MyClubsView } from "../views/myClubsView";
export const MyClubPresenter = connect(
    mapStateToMyClubsProps,
    mapDispatchToMyClubsProps,
)(MyClubsView)